import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-teste',
  standalone: true,
  imports: [],
  templateUrl: './loader-teste.component.html',
  styleUrl: './loader-teste.component.scss'
})
export class LoaderTesteComponent {
  @Input() size: 'small' | 'middle' | 'large' = 'middle';
}
